import React, { useEffect, useState } from 'react';

import { Box, Fade, FormControlLabel } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import { AppCheckbox } from '../../../components/inputs';
import { VatNumberField } from '../../../components/controlled-inputs';

interface Props {
  disabled?: boolean;
  value?: string;
  loading?: boolean;
  verified?: boolean;
}

export const VATRegisteredInput: React.FC<Props> = ({ disabled, ...vatFieldProps }) => {
  const { getValues, setValue } = useFormContext();
  const [isVatRegistered, setIsVatRegistered] = useState<boolean>(!!getValues('vat_reg_number'));

  useEffect(() => {
    if (!isVatRegistered) {
      setValue('vat_reg_number', null);
    }
    setValue('vat_registered', isVatRegistered);
  }, [isVatRegistered]);

  return (
    <Box>
      <Box display="flex" marginTop={1} width="100%">
        <FormControlLabel
          control={
            <AppCheckbox
              onChange={e => setIsVatRegistered(e.target.checked)}
              disabled={disabled}
              color="primary"
              checked={isVatRegistered}
            />
          }
          label="Are you VAT Registered?"
        />
      </Box>

      {isVatRegistered && (
        <Fade timeout={500} in={true}>
          <Box width="100%" marginTop={2} display="flex" alignItems="center">
            <VatNumberField {...vatFieldProps} />
          </Box>
        </Fade>
      )}
    </Box>
  );
};
